import React from 'react'
import MaterialSymbol from '../material-symbol'

const Redeem = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="redeem" {...props} />
))

Redeem.displayName = 'Redeem'

export default Redeem
